export default __webpack_public_path__ + "static/media/block_card-bg.2e3a3066.png";